import { createAction } from "@reduxjs/toolkit";
import type { UpdateProviderSettingsBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export interface UpdateProviderSettingsParams {
  providerId: string;
  body: UpdateProviderSettingsBody;
}

export const updateProviderSettings = createApiThunk<string, UpdateProviderSettingsParams>(
  "admin/providers/updateSettings",
  async ({ providerId, body }, { extra: { adminRepository } }) => {
    await adminRepository!.updateProviderSettings(providerId, body);
    return providerId;
  },
);

export const resetUpdateProviderSettings = createAction("admin/providers/resetUpdateSettings");
